import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

// const Categories = ({ categories }) => {
const Categories = ({catslug , subcat }) => {
    // console.log("Categories component received categoryId:", categories);

    if (!subcat || subcat.length === 0) {
        return null;
    }

    return (
        <div className="lg:border lg:border-[#D7DFE6] lg:px-[28px] lg:py-[16px]">
            <h2
                className="text-2xl leading-[40px] tracking-[0] align-middle mb-[12px] text-[#202124]"
            >
                Explore more categories
            </h2>
            <div className="flex flex-wrap gap-[6px]">
                {subcat.map((item) => (
                    <Link
                        key={item?.id}
                        // href={`/blog?categoryId=${item?.category?.data?.id}&subcategoryId=${item?.id}`}
                        href={`/blog/${catslug}/${item?.slug}`}
                    >
                        <div
                            className="flex items-center gap-[8px] px-[16px] py-[10px] bg-[#EEF4F9] rounded-[40px] hover:bg-[#EDF0F3] transition-colors cursor-pointer"
                        >
                            {item?.icon && (
                                <div className="relative w-[20px] h-[20px] flex-shrink-0">
                                    <Image
                                        src={item?.icon?.url || item?.icon}
                                        alt={item?.name || "Icon"}
                                        fill
                                        sizes="20px"
                                        className="object-contain"
                                    />
                                </div>
                            )}
                            <span
                                className="text-[14px] leading-[100%] tracking-[0] text-[#000000]"
                                style={{ fontFamily: "saans-regular" }}
                            >
                                {item?.name}
                            </span>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default Categories;
